import { Box, Grid } from "@material-ui/core";
import {
    Collections,
    durationTypeDescription,
    Incident,
    StatusRound,
    StatusRoundDescription,
    useCollection,
    useRounds,
} from "api";
import { Round } from "api/model";
import { DateTime } from "luxon";
import MaterialTable from "material-table";
import React, { useState } from "react";
import { useFirestore } from "react-redux-firebase";
import { useHistory } from "react-router";
import { RoundForm } from "ui/views/ChampionshipForm/RoundForm";
import { red } from "@material-ui/core/colors";

const collectionName = "rounds";

interface RaceListProps {
    championshipId: string;
    seasonId: string;
}

const RoundList: React.FC<RaceListProps> = ({ championshipId, seasonId }) => {
    const history = useHistory();
    const rounds: Round[] = useRounds({ championshipId });
    const firestore = useFirestore();
    const tracksById =
        useCollection<any>({ collection: Collections.TRACKS }) || {};
    const [roundEdit, setRoundEdit] = useState<Round>();

    return (
        <Grid container spacing={1}>
            <Grid item xs={12}>
                <RoundForm
                    championshipId={championshipId}
                    seasonId={seasonId}
                    round={roundEdit}
                    onCancel={() => setRoundEdit(undefined)}
                />
            </Grid>
            <Grid item xs={12}>
                <MaterialTable
                    components={{ Container: Box }}
                    columns={[
                        {
                            title: "Etapa",
                            field: "roundNum",
                            align: "center",
                            editable: "never",
                        },
                        {
                            title: "Pista antes do cadastro",
                            field: "trackName",
                        },
                        {
                            title: "Pista",
                            field: "trackId",
                            render: (round) => {
                                return `${
                                    tracksById[round.trackId || ""]
                                        ?.friendlyName
                                } - ${round.trackCourse}`;
                            },
                        },
                        {
                            title: "Data",
                            field: "date",
                            render: (round) =>
                                DateTime.fromISO(round.date).toFormat(
                                    "dd/MM/yyyy"
                                ),
                        },
                        {
                            field: "duration",
                            title: "Duração",
                            render: (round) =>
                                `${
                                    round.duration || ""
                                } ${durationTypeDescription(
                                    round.durationType
                                )}`,
                        },
                        {
                            title: "Status",
                            field: "status",
                            render: (round) =>
                                StatusRoundDescription[round.status],
                        },
                    ]}
                    data={rounds}
                    actions={[
                        (round) => ({
                            hidden: round.status !== StatusRound.CREATED,
                            tooltip: "Remover",
                            icon: "delete",
                            onClick: (event, round) =>
                                firestore
                                    .collection(collectionName)
                                    .doc(round["id"])
                                    .delete(),
                        }),
                        (round) => ({
                            tooltip: "Editar",
                            icon: "edit",
                            onClick: () => setRoundEdit(round),
                        }),
                        {
                            tooltip: "Ir para moderação",
                            icon: "description",
                            onClick: (event, round) => {
                                history.push(
                                    `/race_control/${round["id"]}/false`
                                );
                            },
                        },
                        {
                            tooltip: "Mensagens para transmissão",
                            icon: "dvr",
                            onClick: (event, round) => {
                                history.push(
                                    `/broadcast_messages/${round["id"]}`
                                );
                            },
                        },
                    ]}
                    options={{
                        sorting: false,
                        draggable: false,
                        paging: false,
                        toolbar: false,
                        rowStyle: (data) => {
                            const row = data as Incident;
                            if (row.id === roundEdit?.id) {
                                return {
                                    backgroundColor: red["100"],
                                };
                            }
                            return {};
                        },
                    }}
                />
            </Grid>
        </Grid>
    );
};

export { RoundList };
